export default "<!--The content below is only a placeholder and can be replaced.-->\n<router-outlet>\n\n</router-outlet>\n";